import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as actions from 'Actions';
import {
  Copy,
  Venue,
  Items,
  Company,
  Contacts,
  StarIcon,
  ImportCircle,
} from '../utils/SvgIcons';
import service from 'Api/service';
import { saveError } from 'Api';
import LoadingSpinner from 'Utils/LoadingSpinner';
import ImportWizardHeader from './ImportWizardHeader';
import PaginationBoxView from 'Utils/PaginationBoxView';
import { history } from 'Components/utils/router/history';
import Modal from 'Utils/Modal';
import { selectCheckPermission } from 'HelperFunctions/locations';
import originalTerminologies from '../../helper_functions/originalTerminologies';
import { downloadExampleCsv } from 'HelperFunctions/import_wizard';
import RecentTranslations from './RecentTranslations';
import { Items as BundleIcon } from '../utils/SvgIcons';

class ImportWizardSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      importHistories: [],
      loading: true,
      totalPages: 1,
      page: 1,
      totalObjects: 0,
      perPage: 5,
      isImportHappening: false,
      selectedOption: '',
      pending: null,
      confirmationModal: false,
    };
  }

  componentDidMount() {
    this.fetchHistories();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.business &&
      !prevProps.business.permissions.importWizardEnabled
    ) {
      history.push('/unauthorized');
    }
  }

  fetchHistories = () => {
    const { perPage, page } = this.state;
    service
      .get(
        `${
          import.meta.env.VITE_API_DOMAIN
        }/api/import_histories?per=${perPage}&page=${page}`
      )
      .then((response) => {
        this.setState({
          importHistories: response.data.importHistories,
          loading: false,
          ...response.data.meta?.pagination,
        });
      })
      .catch((error) => {
        this.setState({ loading: false, displayError: true });
        saveError(error);
      });
  };

  handlePageChange = (pagination) => {
    this.setState({ page: pagination.selected + 1 }, () =>
      this.fetchHistories()
    );
  };

  handleOptionSelect = () => {
    const { selectedOption } = this.state;

    return history.push(`/importWizard/upload/${selectedOption}`);
  };

  continueImport = () => {
    const { selectedOption } = this.state;
    return history.push(`/importWizard/adjust/${selectedOption}`);
  };

  checkOngoingImport = (optionUrl) => {
    service
      .get(
        `${
          import.meta.env.VITE_API_DOMAIN
        }/api/imports?import_type=${optionUrl}`
      )
      .then((response) => {
        const { pending } = response.data;
        if (pending) {
          return this.setState({
            confirmationModal: true,
            selectedOption: optionUrl,
          });
        } else {
          this.setState(
            {
              selectedOption: optionUrl,
            },
            () => {
              this.handleOptionSelect();
            }
          );
        }
      })
      .catch((error) => {
        this.setState({ loading: false, displayError: true });
        saveError(error);
      });
  };

  renderOptions = (options) => {
    return options.map((option) => (
      <span key={option.name} className='ImportOption'>
        {option.comingSoon && <div className='banner'>COMING SOON</div>}
        <span
          onClick={(e) =>
            option.comingSoon ? '' : this.checkOngoingImport(option.url)
          }
        >
          <div className='Header'>
            <span>{option.name}</span>
            <ImportCircle />
          </div>
          <div className='CircleStyle'>
            <div>{option.svg}</div>
          </div>
        </span>
        <a
          href='#'
          id={`import_wizard_example_${option.url}`}
          onClick={(event) => {
            event.preventDefault();
            downloadExampleCsv(option.url).catch((error) => {
              this.props.setErrors(
                'Unable to download the example CSV. Please try again.'
              );
              saveError(error);
            });
          }}
        >
          {`Example ${option.name} CSV`}
        </a>
        {option.minimalCsv && (
          <a href='' download='example_spreadsheet'>
            {`Minimal ${option.name} CSV`}
          </a>
        )}
      </span>
    ));
  };

  renderHistories = (histories) => {
    const { purchasePlural } = originalTerminologies();

    const prettyNames = {
      product: 'Items',
      add_on: purchasePlural,
      accessory: 'Accessories',
      bundle: 'Bundles',
      venue: 'Venues',
      customer: 'Customers',
      company: 'Companies',
    };
    return histories.map((history) => (
      <tr>
        <td>
          <b>{history.authorName}</b>
        </td>
        <td>{history.createdAt}</td>
        {history.action === 'revert' ? (
          <td>
            Revert <b>{prettyNames[history.importType]}</b>
          </td>
        ) : (
          <td>
            Bulk Import <b>{prettyNames[history.importType]}</b>
          </td>
        )}
      </tr>
    ));
  };

  closeConfirmationModal = () => {
    this.setState({ confirmationModal: false });
  };

  onGoingImportModal = (confirmationModal, selectedOption) => {
    return (
      <Modal
        open={confirmationModal}
        toggle={this.closeConfirmationModal}
        title='There is already an import happening. Do you want to start a new one?'
        actions={[
          <a
            id='export_in_progress_ok'
            className='btn full'
            onClick={this.handleOptionSelect}
          >
            Start New Import
          </a>,
          <a
            id='export_in_progress_ok'
            className='btn full'
            onClick={this.continueImport}
          >
            Continue Existing Import
          </a>,
          <a
            id='export_in_progress_ok'
            className='btn full'
            onClick={this.closeConfirmationModal}
          >
            Cancel
          </a>,
        ]}
      >
        <p>
          Proceeding with this action will delete all ongoing {selectedOption}{' '}
          import data.
        </p>
      </Modal>
    );
  };

  render() {
    const {
      importHistories,
      loading,
      totalPages,
      page,
      confirmationModal,
      selectedOption,
    } = this.state;
    const { purchasePlural } = originalTerminologies();
    const options = [
      {
        name: 'Items',
        svg: <Items />,
        url: 'item',
        comingSoon: false,
      },
      {
        name: 'Accessories',
        svg: <StarIcon />,
        url: 'accessory',
        comingSoon: false,
      },
      {
        name: purchasePlural,
        svg: <Copy />,
        url: 'purchase',
        comingSoon: false,
      },
      {
        name: 'Bundles',
        svg: <BundleIcon />,
        url: 'bundle',
        comingSoon: false,
      },
      {
        name: 'Customers',
        svg: <Contacts />,
        url: 'customer',
        comingSoon: false,
      },
      {
        name: 'Companies',
        svg: <Company />,
        url: 'company',
        comingSoon: false,
      },
      {
        name: 'Venues',
        svg: <Venue />,
        url: 'venue',
        comingSoon: false,
      },
    ];

    return (
      <div>
        <ImportWizardHeader
          importStatus='selectType'
          headerTitle='Select Data Type To Import'
        />
        <div className='ImportWizardSelectBody'>
          {this.props.business?.permissions?.dreamImportWizardEnabled && (
            <p className='dreamImportBanner'>
              Have files from another system?{' '}
              <Link id='import_wizard_dream_link' to='/importWizard/translate'>
                Drop any files
              </Link>{' '}
              and we translate them into these templates for you.
            </p>
          )}
          {this.props.business?.permissions?.dreamImportWizardEnabled && (
            <RecentTranslations
              businessId={this.props.business.id}
              pendingOnly
              title='Translated imports waiting for you'
            />
          )}
          <div className='ImportWizardOptions'>
            {this.renderOptions(options)}
          </div>
          <div className='ImportHistories'>
            <table className='grid'>
              <thead>
                <tr>
                  <th>Person</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <tbody>
                  {importHistories?.length > 0
                    ? this.renderHistories(importHistories)
                    : 'No History '}
                </tbody>
              )}
            </table>
            <PaginationBoxView
              className='pagerWrapper'
              containerClassName='pager'
              pageCount={totalPages}
              onPageChange={this.handlePageChange}
              forcePage={page - 1}
            />
          </div>
        </div>
        {this.onGoingImportModal(confirmationModal, selectedOption)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const checkPermission = selectCheckPermission(state);
  const { business } = state.business;

  return { business, checkPermission };
};

export default withRouter(
  connect(mapStateToProps, actions)(ImportWizardSelect)
);
